/** Nest ConnectorAccessGuard 403 when the plan lacks the channel connector. */
export const FEATURE_NOT_IN_PLAN_CODE = "FEATURE_NOT_IN_PLAN";

export type FeatureNotInPlanDetails = {
  code: typeof FEATURE_NOT_IN_PLAN_CODE;
  connector: string | null;
  channel: string | null;
};

function readCodeObject(payload: unknown): Record<string, unknown> | null {
  if (!payload || typeof payload !== "object") return null;
  const body = payload as Record<string, unknown>;
  if (body.code === FEATURE_NOT_IN_PLAN_CODE) return body;
  if (
    body.message &&
    typeof body.message === "object" &&
    (body.message as Record<string, unknown>).code === FEATURE_NOT_IN_PLAN_CODE
  ) {
    return body.message as Record<string, unknown>;
  }
  return null;
}

export const parseFeatureNotInPlan = (
  payload: unknown,
): FeatureNotInPlanDetails | null => {
  const obj = readCodeObject(payload);
  if (!obj) return null;
  return {
    code: FEATURE_NOT_IN_PLAN_CODE,
    connector: typeof obj.connector === "string" ? obj.connector : null,
    channel: typeof obj.channel === "string" ? obj.channel : null,
  };
};
